module.exports = __webpack_public_path__ + "static/img/value-bg.b3cdd1f1.png";